import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import { __ } from '../../../../i18n/l10n';
import colors from '../../../../styled-components/palette';

const Wrapper = styled.div``;

const Transformer = styled.div`
  padding: 0.125em 0.6em;
  border-radius: 1em;
  font-family: 'BettingArchivoNarrow', sans-serif;
  font-size: 1.3em;
  font-weight: bold;
  user-select: none;
  transition: none 150ms ease-in-out;
  transition-property: filter, transform;
  text-align: center;
  position: relative;
  cursor: pointer;

  background-color: ${colors.redwinamax500};
  color: ${colors.white};
  box-shadow: 0 2px 0 0 #91082a;

  ${Target.__MOBILE__
    ? css`
        &:active {
          filter: brightness(108%);
          transform: scale(0.96);
        }
      `
    : css`
        &:hover {
          filter: brightness(108%);
        }
        &:active {
          transform: scale(0.96);
        }
      `}
`;

type GRRulesButtonPropsType = {
  className?: string;
  onClick: () => void;
};

const GRRulesButton = ({ className = '', onClick }: GRRulesButtonPropsType) => {
  return (
    <Wrapper className={className} onClick={onClick}>
      <Transformer>{__('!noun:Rules')}</Transformer>
    </Wrapper>
  );
};

export default GRRulesButton;
